module.exports = __webpack_public_path__ + "media/promo/hochland/images/ball2-2ae41b8ee2faff6fb2bd00551cf3d1f9.png";